import { Property } from "./Property";
export default Property;
export * from "./Property";
